import { decodeRun, encodeRun, type RunSave } from "../core/save";
import type { BattleConfig, BattleState } from "../core/types";

const RUN_SAVE_KEY = "egg-arena:run:v1";

export function loadSavedRun(): RunSave | null {
  try {
    const encoded = window.localStorage.getItem(RUN_SAVE_KEY);
    if (!encoded) return null;
    const save = decodeRun(encoded);
    if (!save) window.localStorage.removeItem(RUN_SAVE_KEY);
    return save;
  } catch {
    return null;
  }
}

export function saveRunSnapshot(
  state: BattleState,
  config: BattleConfig,
): boolean {
  try {
    window.localStorage.setItem(RUN_SAVE_KEY, encodeRun(state, config));
    return true;
  } catch {
    return false;
  }
}

export function clearSavedRun(): void {
  try {
    window.localStorage.removeItem(RUN_SAVE_KEY);
  } catch {
    // A failed cleanup must never stop a new run from starting.
  }
}

